// libs/core/src/lib/storage/storage.ts
var Storage = class {
  constructor(config) {
    this.config = config;
    this.storage = getStorage();
  }
  get prefix() {
    return this.config.storagePrefix ?? "";
  }
  get separator() {
    return this.config.storageSeparator ?? ":";
  }
  set(key, data) {
    if (!this.storage) return;
    try {
      const _key = this.key(key);
      const strData = typeof data !== "string" ? JSON.stringify(data) : data;
      this.storage.setItem(_key, strData);
    } catch (error) {
      console.warn(error);
    }
  }
  get(key, parser) {
    if (!this.storage) return null;
    try {
      const _key = this.key(key);
      const strData = this.storage.getItem(_key);
      if (strData === null) return null;
      return parser(strData);
    } catch (error) {
      console.warn(error);
      return null;
    }
  }
  remove(key) {
    if (!this.storage) return;
    try {
      const _key = this.key(key);
      this.storage.removeItem(_key);
    } catch (error) {
      console.warn(error);
    }
  }
  update(key, updates) {
    const value = this.get(key, JsonParser);
    const newValue = updates(value);
    this.set(key, newValue);
    return newValue;
  }
  updateEntity(key, entityKey, value) {
    const entity = this.get(key, JsonParser) ?? {};
    const newEntity = { ...entity, [entityKey]: value };
    this.set(key, newEntity);
  }
  key(rawKey) {
    return [this.prefix, rawKey].join(this.separator);
  }
};
function getStorage() {
  if (isSupportedStorage(window.localStorage)) {
    return window.localStorage;
  }
  if (isSupportedStorage(window.sessionStorage)) {
    return window.sessionStorage;
  }
  return null;
}
function isSupportedStorage(storage2) {
  if (window?.localStorage) {
    try {
      storage2.setItem("@__test__@", "1");
      const item1 = window.localStorage.getItem("@__test__@");
      storage2.removeItem("@__test__@");
      const item2 = storage2.getItem("@__test__@");
      return item1 === "1" && item2 === null;
    } catch {
      return false;
    }
  }
  return false;
}
function JsonParser(value) {
  return JSON.parse(value);
}
var storage = new Storage({
  storagePrefix: "one-inch",
  storageSeparator: ":"
});
export {
  JsonParser,
  Storage,
  storage
};
//# sourceMappingURL=index.esm.js.map
